var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 8.58123V17.2484C18 18.0768 17.3284 18.7484 16.5 18.7484H12.75C11.9216 18.7484 11.25 18.0768 11.25 17.2484V13.4984C11.25 13.0842 10.9142 12.7484 10.5 12.7484H7.5C7.08579 12.7484 6.75 13.0842 6.75 13.4984V17.2484C6.75 18.0768 6.07843 18.7484 5.25 18.7484H1.5C0.671573 18.7484 0 18.0768 0 17.2484V8.58123C-6.38962e-05 8.1615 0.17573 7.76095 0.484688 7.47685L7.98469 0.400601L7.995 0.390288C8.56719 -0.130086 9.44124 -0.130086 10.0134 0.390288C10.0166 0.393956 10.0201 0.397402 10.0238 0.400601L17.5238 7.47685C17.8296 7.76243 18.0022 8.16279 18 8.58123Z",
    fill: "#AD11F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardIcon);
export default __webpack_public_path__ + "static/media/DashboardIcon.75796f5b91a92f7e189a443c54aede53.svg";
export { ForwardRef as ReactComponent };